import React from 'react';
import { FormControl, InputLabel, Select, OutlinedInput, Box, Chip, MenuItem } from '@mui/material';


function MultiSelect ({inputLabel = '', values = [], valuesState = [], labelFunction = (v) => v?.name || v?.code || '', onChange}) {
    const idValue = (inputLabel || '').replace(/\s+/g, '');
    const safeValues = Array.isArray(values) ? values : [];
    const safeValuesState = Array.isArray(valuesState) ? valuesState : [];

    const selectedValue = safeValues.filter((val) =>
        safeValuesState.some(item => (item?.id !== undefined && item?.id === val?.id) || item === val)
    );

    return (
        <FormControl sx={{ m: 1, width: 200}}>
            <InputLabel id={`id-${idValue}`}>{inputLabel}</InputLabel>
            <Select
                labelId={`id-${idValue}`}
                id={idValue}
                multiple
                value={selectedValue}
                onChange={onChange}
                input={<OutlinedInput id={`select-${idValue}`} label='Chip' />}
                renderValue={(selected) => (
                    <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
                        {Array.isArray(selected) && selected.map((value, idx) => (
                            <Chip key={value?.id ?? idx} label={labelFunction(value)} />
                        ))}
                    </Box>
                )}                                    
            >
                {safeValues.length > 0 ? (safeValues.map((value, idx) => (
                    <MenuItem
                        key={value?.id ?? idx}
                        value={value}
                        selected={safeValuesState.some(item => (item?.id !== undefined && item?.id === value?.id) || item === value)}
                    >
                        {labelFunction(value)}
                    </MenuItem>
                ))) : null}
            </Select>
        </FormControl>
    )
}

export default MultiSelect;